module.exports = __webpack_public_path__ + "static/media/button_submit_arrow.cdf048be.svg";